import { render, staticRenderFns } from "./tenant-branding-images.vue?vue&type=template&id=68390276&"
import script from "./tenant-branding-images.vue?vue&type=script&lang=js&"
export * from "./tenant-branding-images.vue?vue&type=script&lang=js&"
import style0 from "./tenant-branding-images.vue?vue&type=style&index=0&id=68390276&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports